import { render } from "./Index.vue?vue&type=template&id=b205c7c2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=b205c7c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b205c7c2"

export default script